const studentDoor = () =>
    import(/* webpackChunkName: "studentBar" */'../views/bar/door/studentDoor');
export default [

    {
        path: 'studentDoor',
        name: 'studentDoor',
        component: studentDoor
    },
]